module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kTxV6"))).then(() => parcelRequire('1iHdE'));